<template>
  <div class="flex items-center justify-center rounded-[8px] bg-[#F8F9FA] px-[56px] py-[40px]">
    <div class="flex flex-col items-center">
      <img
        class="pointer-events-none block h-[120px] w-auto select-none"
        :src="imgSrc"
        :alt="`There is no ${type} yet.`"
      />
      <div class="mt-[17px] flex flex-col items-center">
        <span class="text-sm font-semibold text-gpx_black-200">
          {{ heading }}
        </span>
        <span class="mt-[1px] text-xs text-gpx_gray-100">
          {{ desc }}
        </span>
        <div v-if="this.$slots.button" class="mt-[24px]">
          <slot name="button"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AchSvg from '../assets/empty_state/ach.svg'
import CCSvg from '../assets/empty_state/cc.svg'
import ListSvg from '../assets/empty_state/list.svg'
import NoteSvg from '../assets/empty_state/note.svg'
import SearchSvg from '../assets/empty_state/search.svg'
import TableSvg from '../assets/empty_state/table.svg'

const svgMap = {
  ach: AchSvg,
  cc: CCSvg,
  list: ListSvg,
  note: NoteSvg,
  search: SearchSvg,
  table: TableSvg
}

export default {
  name: 'EmptyState',
  props: {
    type: {
      type: String,
      required: false,
      validator: (value) => {
        return ['list', 'table', 'note', 'cc', 'ach', 'search'].includes(value)
      },
      default: 'list'
    },
    bg: {
      type: String,
      required: false,
      validator: (value) => {
        return ['dark', 'light'].includes(value)
      },
      default: 'dark'
    },
    heading: {
      type: String,
      required: true
    },
    desc: {
      type: String,
      required: true
    }
  },
  computed: {
    imgSrc() {
      return svgMap[this.type]
    }
  }
}
</script>
